// extracted by mini-css-extract-plugin
module.exports = {"tabsMenuContainer":"GamesContainer_tabsMenuContainer__gJMSy"};